import { useState, useEffect } from 'react';
import { getSDRs, updateStatusDia } from '../services/api';

export function CheckinWidget({ currentUser }) {
    const [status, setStatus] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!currentUser?.nome) return;
        getSDRs()
            .then(sdrs => {
                const me = sdrs.find(s => s.nome === currentUser.nome);
                setStatus(me ? (me.status_dia === 1 ? 1 : 0) : 0);
            })
            .catch(() => setStatus(0));
    }, [currentUser?.nome]);

    if (status === null) return null;

    const ativo = status === 1;

    const toggle = async () => {
        const next = ativo ? 0 : 1;
        setSaving(true);
        try {
            await updateStatusDia(currentUser.nome, !ativo);
            setStatus(next);
        } catch {
            // silent
        } finally {
            setSaving(false);
        }
    };

    return (
        <button
            onClick={toggle}
            disabled={saving}
            title={ativo ? 'Clique para ficar offline' : 'Clique para ficar online'}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.375rem 0.875rem',
                borderRadius: '2rem',
                border: `1px solid ${ativo ? 'rgba(16,185,129,0.4)' : 'rgba(255,255,255,0.12)'}`,
                background: ativo ? 'rgba(16,185,129,0.1)' : 'rgba(255,255,255,0.04)',
                color: ativo ? '#10b981' : 'var(--text-secondary)',
                fontSize: '0.8125rem',
                fontWeight: 500,
                cursor: saving ? 'wait' : 'pointer',
                transition: 'all 0.2s',
                opacity: saving ? 0.6 : 1,
                outline: 'none',
            }}
        >
            <div style={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                background: ativo ? '#10b981' : 'rgba(255,255,255,0.3)',
                boxShadow: ativo ? '0 0 6px #10b981' : 'none',
                flexShrink: 0,
                transition: 'all 0.2s',
            }} />
            {saving ? '...' : ativo ? 'Online' : 'Offline'}
        </button>
    );
}
